module.exports = __webpack_public_path__ + "static/media/countries.43b0188a.csv";